import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {dataToolSchemas} from '../../utils/schemas';

const toolName = 'update-cms-collection-field' as const;

// Schema for updating collection fields
const argumentZod = z.object({
  collectionId: dataToolSchemas.collectionId,
  fieldId: dataToolSchemas.fieldId,
  displayName: z.string().optional().describe('New display name for the field'),
  isRequired: z
    .boolean()
    .optional()
    .describe('Whether the field should be required'),
  helpText: z.string().optional().describe('Help text for the field'),
});

export const updateCMSCollectionFieldManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Update CMS collection field',
  family: 'cms',
  llmTool: {
    name: toolName,
    description:
      'Updates an existing field in a CMS collection. Can modify display name, required status, and help text.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [
    {
      resource: 'SiteCollection',
      action: 'manage',
      resolveResources: (args) => [
        {type: 'SiteCollection', id: args.collectionId},
      ],
    },
  ],
  confirmBeforeExecuting: true,
});

export type UpdateCMSCollectionFieldArgumentType = z.infer<typeof argumentZod>;
